import { ROLES } from '@/constants/roles';

export const mailing = {
  path: '/mailing',
  name: 'mailing',
  component: () => import('./views/MailingList.vue'),
  meta: {
    accessList: [ROLES.operator],
    title: 'Рассылка уведомлений',
    icon: 'mdi-email-multiple-outline',
  },
};

const routes = [
  mailing,
  {
    path: '/mailing-create',
    name: 'mailing-create',
    component: () => import('./views/MailingSave.vue'),
    meta: {
      accessList: [ROLES.operator],
      title: 'Рассылка уведомлений',
    },
  },
  {
    path: '/mailing-update/:id',
    name: 'mailing-update',
    component: () => import('./views/MailingSave.vue'),
    meta: {
      accessList: [ROLES.operator],
      title: 'Рассылка уведомлений',
      update: true,
    },
  },
  {
    path: '/mailing/:id',
    name: 'mailing-view',
    component: () => import('./views/MailingView.vue'),
    meta: {
      accessList: [
        ROLES.operator,
        ROLES.member,
        ROLES.certificate,
        ROLES.department,
        ROLES.organization,
      ],
      title: 'Просмотр уведомления',
    },
  },
];
export default routes;
